<template>
  <list-box
    v-if="true"
    :url="`/player/${playerId}/payment_intents`"
    emptyListMessage="No payment intents."
    v-slot="{list: paymentIntents}"
  >
    <table class="table text-nowrap">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Id</th>
          <th scope="col">Time</th>
          <th scope="col">Ext id</th>
          <th scope="col">Payload</th>
          <th scope="col">Status</th>
          <th scope="col">Service</th>
          <th scope="col" class="text-right">Coins</th>
          <th scope="col" class="text-right">Bill id</th>
        </tr>
      </thead>
      <tr
        v-for="paymentIntent in paymentIntents"
        :key="paymentIntent.Id"
      >
        <td>
          {{paymentIntent.Id}}
        </td>
        <td>
          {{paymentIntent.Ctime | getMomentStr}}
        </td>
        <td>
          <span
            v-b-popover.click.top="paymentIntent.ExtId"
            class="tooltip-button custom-code"
          >
            {{paymentIntent.ExtId | extIdStart}}&hellip;
          </span>
        </td>
        <td>
          <span
            v-b-popover.click.top="paymentIntent.Payload"
            class="tooltip-button custom-code"
          >
            {{paymentIntent.Payload | payloadStart}}&hellip;
          </span>
        </td>
        <td
          :class="getStatusClass(paymentIntent.Status)"
        >
          {{paymentIntent.Status | statusName}}
        </td>
        <td>
          {{paymentIntent.Sku | getShortBillingServiceId}}
        </td>
        <td class="text-right">
          {{paymentIntent.Gems | getFormattedDifference}}
        </td>
        <td class="text-right">
          {{paymentIntent.BillId | billIdStr}}
        </td>
      </tr>
    </table>
  </list-box>
</template>

<script>
import ListBox from './util/ListBox.vue';

const IAP_STATUS_ACTIVE   = 0
const IAP_STATUS_COMPLETE = 1
const IAP_STATUS_CONSUMED = 2

export default {
  name: 'PlayerPaymentIntents',

  components: {
    ListBox,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },
  },

  methods: {
    getStatusClass(status) {
      return {
        'payment-intent-active':   status === IAP_STATUS_ACTIVE,
        'payment-intent-complete': status === IAP_STATUS_COMPLETE,
        'payment-intent-consumed': status === IAP_STATUS_CONSUMED,
      };
    },
  },

  filters: {
    extIdStart(extId) {
      return extId.substring(0, 8);
    },

    payloadStart(payload) {
      return payload.substring(0, 4);
    },

    statusName(code) {
      switch(code) {
        case IAP_STATUS_ACTIVE: return 'incomplete';
        case IAP_STATUS_COMPLETE: return 'complete';
        case IAP_STATUS_CONSUMED: return 'consumed';
      }
      return `Unknown status code ${code}.`;
    },

    billIdStr(billId) {
      if(billId === 0) {
        return '---'
      }
      return billId.toString();
    },
  },
};
</script>

<style scoped>
.tooltip-button {
  text-decoration: underline;
  cursor: pointer;
}

.popover {
  max-width: 800px;
  font-family: monospace;
}

.payment-intent-active {
  /*background-color: #e6c3c3;*/
  /*background-color: rgb(248, 243, 215)*/
  /*background-color: var(--yellow);*/
  background-color: #ffff72;
}

.payment-intent-complete {
  /*background-color: #c3e6cb;*/
  background-color: rgba(212, 237, 218);
}

.payment-intent-consumed {
  /*background-color: #dff5f5;*/
  background-color: rgba(222, 245, 245);
}
</style>
